////////////////////////////////////////////////////////////////////////////////
// Copyright 2019 Federated Wireless.
//
// GOVERNMENT PURPOSE RIGHTS
//
// Contractor Name:    Federated Wireless
// Contractor Address: 3865 Wilson Blvd, Arlington, VA 22203
//
// The Government's rights to use, modify, reproduce, release, perform, display,
// or disclose this software are restricted by paragraph (b)(2) of the Rights in
// Noncommercial Computer Software and Noncommercial Computer Software
// Documentation clause contained in the 7013 Clause. Any reproduction of the
// software or portions thereof marked with this legend must also reproduce the
// markings.
// This source code delivery is exclusively for Government Purposes pertaining
// to this program; no commercial use. The Computer Software Configuration
// Items were delivered for only the purposes spelled out by the contract
// delivered under.
//
// Export Warning - The technical data in this document (or file) is
// controlled for export under the International Traffic in Arms Regulations
// (ITAR), 22CFR 120-130.  Violations of these export laws may be subject to
// fines and penalties under the Arms Export Control Act (22 U.S.C. 2778).
//
////////////////////////////////////////////////////////////////////////////////
//
// Security Classification: UNCLASSIFIED
//
////////////////////////////////////////////////////////////////////////////////


import React, { Component } from 'react'
import MapSelection from './MapSelection'
import ProjectOverview from './ProjectOverview'
import AnalysisDetails from './AnalysisDetails'
import MNOConsultation from './MNOConsultation'
import TransmittingStations from './TransmittingStations'
import Review from './Review'
import { Modal} from 'react-bootstrap';
import {Redirect } from "react-router-dom";
import axios from 'axios'
import Stepper from 'react-stepper-horizontal';//https://www.npmjs.com/package/react-stepper-horizontal

import { requestConstants } from '../../constants';

const https = require('https');

let initialValues = {initialValues: {licenceename: "eric"} }


class NewTddForm extends Component {
  constructor(props) {
    super(props)
    this.nextPage = this.nextPage.bind(this)
    this.previousPage = this.previousPage.bind(this)
    this.saveAndExit = this.saveAndExit.bind(this)
    this.updatePageState = this.updatePageState.bind(this)
    this.getPageState = this.getPageState.bind(this)
    this.saveMapImage = this.saveMapImage.bind(this)
    this.prepareMapBackgroundForSave = this.prepareMapBackgroundForSave.bind(this)
    this.state = {
      currentPage: 1,
      selectedAreas: [],
      submitted: false,
      wizardInitialized: false,
      failed:false,
      default_center:{
        lat: 38.9072,
        lng: -77.0369,
      },
      updateData: false,
      requestID: this.props.requestInfo.request_id,
      skip_analysis: this.props.requestInfo.skip_analysis,
      saveAndExit:false,
      loadAreaSelection: false,
      requestInfo: {},
      imageCaption:"",
      savedMapImages: {}
    }

    if (this.props.requestInfo && this.props.requestInfo.pageStates){
        this.state.pageStates=this.props.requestInfo.pageStates
    } else {
        this.state.pageStates = {
        }
    }

    }

  updatePageState = (pageName, state) => {
      let currentStates = this.state.pageStates
      currentStates[pageName]= {
        ...currentStates[pageName],
        ...state
      }
      this.setState({pageStates:currentStates})
  }

  getPageState = (pageName) => {
      return this.state.pageStates[pageName]
  }


  updateAPI(data) {
    let URL = ''
    data["user_id"] = localStorage.getItem("user_id")

    URL = `${this.props.SERVER_URLS.api}/request/${this.state.requestID}`
    return axios.put(URL, data)
  }

  nextPage(data)  {
    let updateData = {"request_state": this.state.currentPage + 1}
    updateData["payload"] = {
        "pageStates": this.state.pageStates,
        "savedMapImages": this.state.savedMapImages

    }
    this.updateAPI(updateData)
    this.setState({ currentPage: this.state.currentPage + 1 })

  }

  previousPage() {
    let updateData = {"request_state": this.state.currentPage-1}
    updateData["payload"] = {
        "pageStates": this.state.pageStates,
        "savedMapImages": this.state.savedMapImages
    }
    this.updateAPI(updateData)
    this.setState({ currentPage: this.state.currentPage - 1 })
  }

  formatNewlines(string){
    let splitstring = string.split("\n")
    let html = []
    for (let line of splitstring){
      html.push(line)
      html.push(<br key={line}/>)
    }
    return html
  }

  saveAndExit(data){
    let updateData = {"request_state": this.state.currentPage}
    updateData["payload"] = {
      "pageStates": this.state.pageStates,
      "savedMapImages": this.state.savedMapImages
    }
    this.updateAPI(updateData)
    this.setState({saveAndExit:true})
  }

  getMapOptions() {
    return {
      gestureHandling:'greedy'
      //panControl: false,
      //mapTypeControl: false,
      //scrollwheel: false,
      //styles: [{ stylers: [{ 'saturation': -100 }, { 'gamma': 0.8 }, { 'lightness': 4 }, { 'visibility': 'on' }] }]
    }
  }

  componentDidMount() {
    let URL = `${this.props.SERVER_URLS.api}/request/${this.props.requestInfo.request_id}?id=${encodeURIComponent(localStorage.getItem("user_id"))}`
    axios.get(URL, {httpsAgent: new https.Agent({  
        //rejectUnauthorized: false
      })} )
    .then(response => {
      if(response.data) { //has previous request
        this.setState({
            pageStates: response.data.pageStates ? response.data.pageStates : {},
            currentPage: (response.data.request_state && response.data.request_state>0) ? response.data.request_state : 1,
            savedMapImages: response.data.savedMapImages ? response.data.savedMapImages : {},
            wizardInitialized: true
        })
      }
    }
      )
    .catch(
      function(error) {
        console.log(
        error
      )
    })

  }

  gotoPage(page)  {
    let updateData = {"request_state": page}
    let data = {"pageStates":this.state.pageStates}
    updateData["payload"] = data
    this.updateAPI(updateData)
    this.setState({updateData: false})
    this.setState({ currentPage: page })
  }

  prepareMapBackgroundForSave(callback) {
    // pre-emptively prepare the map background tiles for being saved (avoid 'tainted canvas' problems)
    for (let z of document.getElementsByTagName("img")) {
      if (z.currentSrc.includes("://maps.googleapis.com") || z.currentSrc.includes("://maps.google.com") || z.currentSrc.includes("mno_coverage")) {
        z.crossOrigin = "Anonymous"; // needed so that canvas will allow toDataUrl
      }
    }

    // ideally we'd have a promise from when the browser has finished reloading the tiles,
    // but it isn't clear how we might obtain one; timeout is a dirty hack but it will probably do.
    if (callback) {
      setTimeout(callback, 2000);
    }
  }

  saveMapImage(imageName) {
    console.log("saveMapImage")
    // export google maps content to a base64 image string

    // gather the various elements and their offset
    // Google maps background tiles are img, data overlay are canvas
    const mapElements = {
      canvas: [],
      img: [],
      markers: [],
      overlay: []
    };

    // The img and canvas are each inside divs with offsets relative to one of two master divs, which are
    // themselves offset by a transform property
    // record the range of (normalized) offsets so we can set the bounds of the output image
    let imgOffsetLeftRange = [999, -999];
    let imgOffsetTopRange = [999, -999];
    let imgAbsoluteLeftTop = [9999, 9999];
    let canvasOffsetLeftRange = [999, -999];
    let canvasOffsetTopRange = [999, -999];
    let overlayOffsetLeftRange = [999, -999];
    let overlayOffsetTopRange = [999, -999];
    let mapAbsoluteLeftTop = null;
    
    for (let z of document.getElementsByTagName("img")) {
      if (z.currentSrc.includes("://maps.googleapis.com") || z.currentSrc.includes("://maps.google.com")) {
        console.log(z.crossOrigin);
        if (z.crossOrigin !== "anonymous")
          throw "google maps tile does not have crossOrigin=anonymous"
        const transform = z.parentNode.parentNode.style.transform.split(',');
        const masterLeftOffset = parseInt(transform[4].trim());
        const masterTopOffset = parseInt(transform[5].trim());

        // record the DOM IMG element, along with a normalized offset
        mapElements.img.push({dom: z, offset: [z.parentNode.offsetLeft + masterLeftOffset, z.parentNode.offsetTop + masterTopOffset]});

        imgOffsetLeftRange[0] = Math.min(imgOffsetLeftRange[0], z.parentNode.offsetLeft + masterLeftOffset);
        imgOffsetLeftRange[1] = Math.max(imgOffsetLeftRange[1], z.parentNode.offsetLeft + masterLeftOffset);
        imgOffsetTopRange[0] = Math.min(imgOffsetTopRange[0], z.parentNode.offsetTop + masterTopOffset);
        imgOffsetTopRange[1] = Math.max(imgOffsetTopRange[1], z.parentNode.offsetTop + masterTopOffset);

        let imgBoundingRect = z.getBoundingClientRect();

        imgAbsoluteLeftTop[0] = Math.min(imgAbsoluteLeftTop[0], imgBoundingRect.left);
        imgAbsoluteLeftTop[1] = Math.min(imgAbsoluteLeftTop[1], imgBoundingRect.top);
      } else if (z.currentSrc.startsWith("data:image/png;base64") && z.draggable === false) {
        if (!mapAbsoluteLeftTop) {
          const mapViewport = z.parentNode.parentNode.parentNode.parentNode.getBoundingClientRect();
          mapAbsoluteLeftTop = [mapViewport.left, mapViewport.top];
        }

        mapElements.markers.push({
          dom: z,
          offsetViewport: [
            z.parentNode.offsetLeft + z.parentNode.parentNode.parentNode.parentNode.offsetWidth/2,
            z.parentNode.offsetTop + z.parentNode.parentNode.parentNode.parentNode.offsetHeight/2
          ]
        })
      } else if (z.currentSrc.includes("mno_coverage")) {
        console.log(z.crossOrigin);
        if (z.crossOrigin !== "anonymous")
          throw "mno_coverage tile does not have crossOrigin=anonymous"
        const transform = z.parentNode.parentNode.parentNode.style.transform.split(',');
        const masterLeftOffset = parseInt(transform[4].trim());
        const masterTopOffset = parseInt(transform[5].trim());

        mapElements.overlay.push({
          dom: z,
          offset: [
            z.parentNode.parentNode.offsetLeft + masterLeftOffset,
            z.parentNode.parentNode.offsetTop + masterTopOffset
          ]
        })
        
        overlayOffsetLeftRange[0] = Math.min(overlayOffsetLeftRange[0], z.parentNode.parentNode.offsetLeft + masterLeftOffset);
        overlayOffsetLeftRange[1] = Math.max(overlayOffsetLeftRange[1], z.parentNode.parentNode.offsetLeft + masterLeftOffset);
        overlayOffsetTopRange[0] = Math.min(overlayOffsetTopRange[0], z.parentNode.parentNode.offsetTop + masterTopOffset);
        overlayOffsetTopRange[1] = Math.max(overlayOffsetTopRange[1], z.parentNode.parentNode.offsetTop + masterTopOffset);
      }
    }

    if (mapElements.img.length < 9)
      throw "<9 google maps tiles"
    if (mapElements.overlay.length > 0 && mapElements.overlay.length < 9)
      throw "<9 mno coverage tiles"

    for (let z of document.getElementsByTagName("canvas")) {
      // TODO figure out how to filter in case there are other canvasses?
      const transform = z.parentNode.parentNode.style.transform.split(',');
      const masterLeftOffset = parseInt(transform[4].trim());
      const masterTopOffset = parseInt(transform[5].trim());

      // record the DOM canvas element, along with a normalized offset
      mapElements.canvas.push({dom: z, offset: [z.parentNode.offsetLeft + masterLeftOffset, z.parentNode.offsetTop + masterTopOffset]});

      canvasOffsetLeftRange[0] = Math.min(canvasOffsetLeftRange[0], z.parentNode.offsetLeft + masterLeftOffset);
      canvasOffsetLeftRange[1] = Math.max(canvasOffsetLeftRange[1], z.parentNode.offsetLeft + masterLeftOffset);
      canvasOffsetTopRange[0] = Math.min(canvasOffsetTopRange[0], z.parentNode.offsetTop + masterTopOffset);
      canvasOffsetTopRange[1] = Math.max(canvasOffsetTopRange[1], z.parentNode.offsetTop + masterTopOffset);
    }

    // Make sure that prepareMapBackgroundForSave() has already been called, preferably in an
    // onTilesLoaded handler.
    // Reason for this is that when we set crossorigin=Anonymous on the background tiles,
    // the browser re-requests them from the server with different headers
    // to check that the server will allow this kind of cross-origin use (it does).
    // We need to wait until this is finished before attaching the new version
    // of the tiles into our fake canvas, from which we will then generate the base64 string.
    // (note that onTilesLoaded is _not_ triggered by the reload)

    // assuming this is always true?
    const tileSize = 256;

    // create a fake canvas (not rendered)
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = imgOffsetLeftRange[1] + tileSize - imgOffsetLeftRange[0];
    canvas.height = imgOffsetTopRange[1] + tileSize - imgOffsetTopRange[0];

    // add the (freshly re-requested) background tiles to the fake canvas
    for (let image of mapElements.img) {
      ctx.drawImage(image.dom, image.offset[0] - imgOffsetLeftRange[0], image.offset[1] - imgOffsetTopRange[0], tileSize, tileSize);
    }

    ctx.globalAlpha = 0.8;
    for (let image of mapElements.overlay) {
      ctx.drawImage(image.dom, image.offset[0] - overlayOffsetLeftRange[0], image.offset[1] - overlayOffsetTopRange[0], tileSize, tileSize);
    }
    ctx.globalAlpha = 1.0;

    // add the data canvas elements to the fake canvas
    for (let cvs of mapElements.canvas) {
      ctx.drawImage(cvs.dom, cvs.offset[0] - imgOffsetLeftRange[0], cvs.offset[1] - imgOffsetTopRange[0], tileSize, tileSize);
    }

    for (let marker of mapElements.markers) {
      ctx.drawImage(marker.dom, marker.offsetViewport[0] + mapAbsoluteLeftTop[0] - imgAbsoluteLeftTop[0],
        marker.offsetViewport[1] + mapAbsoluteLeftTop[1] - imgAbsoluteLeftTop[1], 32, 32);
    }

    // dump the base64 of the whole lot.
    const base64 = canvas.toDataURL('image/jpeg');

    const savedMapImages = this.state.savedMapImages;
    savedMapImages[imageName] = base64;
    this.setState({"savedMapImages": savedMapImages});

    canvas.remove();
  }

  getInitialValues(pageName){
    if (this.state.pageStates.hasOwnProperty(pageName) && this.state.pageStates[pageName].hasOwnProperty("form")){
        return {initialValues: this.state.pageStates[pageName].form }
    }

    return {initialValues: {} }
  }

  render() {
    const { submitted, processing, failed, error_message } = this.state
    if (!this.state.wizardInitialized){
    return(
        <center>
          <h2>Loading ......</h2>
          <div className="transparent-spinner"/>
        </center>)
    } else if (submitted===true){
      return <Redirect to={`/ru/details/${this.state.requestID}`} />
    } else if (this.state.saveAndExit){
        return <Redirect to='/ru/list' />
    } else if (failed===true){
      return(
      <center>
        <h2><font color="red">Failed:<br/><br/></font>{this.formatNewlines(error_message)}</h2>
      </center>)
    } else if  (processing===true){
      return(
      <center>
        <h2>Processing......</h2>
        <div class="transparent-spinner"/>
      </center>)
    }
    return (
          <React.Fragment>
            <h2>Apply for a Local Access Licence</h2>
            <div className='stepper'>
              <Stepper steps={ [
                  {title: 'Project Overview', onClick: ()=> this.gotoPage(1)},
                  {title: 'Assess Availability', onClick: ()=> this.gotoPage(2)},
                  {title: 'Plan Network', onClick: ()=> this.gotoPage(3)},
                  {title: 'Network Analysis', onClick: ()=> this.gotoPage(4)},
                  {title: 'MNO Consultation', onClick: ()=> this.gotoPage(5)},
                  {title: 'Review and Submit Application', onClick: ()=> this.gotoPage(6)}
              ] }
              activeStep={ this.state.currentPage-1 } />{/*https://github.com/apuchenkin/react-stepper*/}
            </div>
            { this.state.currentPage === 1 &&
                  <ProjectOverview
                      SERVER_URLS={this.props.SERVER_URLS}
                      {...this.getInitialValues("ProjectOverview")}
                      onSubmit={(values)=>{
                          this.updatePageState("ProjectOverview", {form: values})
                          this.nextPage()
                        }
                    }                      previousPage={this.previousPage}
                      setLoadAreaSelection={this.setLoadAreaSelection}
                      saveAndExit={this.saveAndExit}
                      saveMapImage={this.saveMapImage}
                      prepareMapBackgroundForSave={this.prepareMapBackgroundForSave}
                      updatePageState={this.updatePageState}
                      getPageState={this.getPageState}
                      id={this.state.requestID}
                  />
              }
              { this.state.currentPage === 2 &&
                  <MapSelection
                      SERVER_URLS={this.props.SERVER_URLS}
                      onSubmit={this.nextPage}
                      previousPage={this.previousPage}
                      setLoadAreaSelection={this.setLoadAreaSelection}
                      saveAndExit={this.saveAndExit}
                      saveMapImage={this.saveMapImage}
                      prepareMapBackgroundForSave={this.prepareMapBackgroundForSave}
                      updatePageState={this.updatePageState}
                      getPageState={this.getPageState}
                      id={this.state.requestID}
                  />
              }
              { this.state.currentPage === 3 &&
                  <TransmittingStations
                  SERVER_URLS={this.props.SERVER_URLS}
                  previousPage={this.previousPage}
                  onSubmit={this.nextPage}
                  requestID={this.state.requestID}
                  saveAndExit={this.saveAndExit}
                  stations={this.state.transmitters}
                  updatePageState={this.updatePageState}
                  getPageState={this.getPageState}
                  allPageStates={this.state.pageStates}
                  />
              }
               { this.state.currentPage === 4 &&
                  <AnalysisDetails
                  SERVER_URLS={this.props.SERVER_URLS}
                  previousPage={this.previousPage}
                  onSubmit={this.nextPage}
                  requestID={this.state.requestID}
                  saveAndExit={this.saveAndExit}
                  saveMapImage={this.saveMapImage}
                  prepareMapBackgroundForSave={this.prepareMapBackgroundForSave}
                  updatePageState={this.updatePageState}
                  getPageState={this.getPageState}
                  allPageStates={this.state.pageStates}
                  />
              }
              { this.state.currentPage === 5 &&
                  <MNOConsultation
                      SERVER_URLS={this.props.SERVER_URLS}
                      id={this.state.requestID}
                      previousPage={this.previousPage}
                      saveAndExit={this.saveAndExit}
                      {...this.getInitialValues("MNOConsultation")}
                      onSubmit={(values)=>{
                          this.updatePageState("MNOConsultation", {form: {...{name:"",address:"",postcode:"",telephone:"",country:"",email:"",mobile:"",fax:""},...values}})
                          this.nextPage()
                        }
                    }
                      updatePageState={this.updatePageState}
                      getPageState={this.getPageState}
                      allPageStates={this.state.pageStates}

                  />
              }
              { this.state.currentPage === 6 &&
                  <Review
                  SERVER_URLS={this.props.SERVER_URLS}
                  id={this.state.requestID}
                  previousPage={this.previousPage}
                  savePDF={(pdf) => {
                    this.updateAPI({
                      payload: {
                        pdfdocument: pdf,
                      },
                    })
                  }}
                  onSubmit={() => {
                    return this.updateAPI({
                      payload: {
                        status: requestConstants.status.SUBMITTED,
                      },
                    }).then(() => this.setState({ currentPage: this.state.currentPage + 1 }));
                  }}
                  requestID={this.state.requestID}
                  saveAndExit={this.saveAndExit}
                  updatePageState={this.updatePageState}
                  getPageState={this.getPageState}
                  allPageStates={this.state.pageStates}
                  />
              }
              { this.state.currentPage > 6 &&
                <Redirect to={`/ru/details/${this.state.requestID}`} />
              }

          </React.Fragment>
    )
  }
}


export default NewTddForm